import { ValueObject } from './value-object';

export class Email extends ValueObject<string> {
  constructor(email: string) {
    const isValid = Email.validate(email);
    if (!isValid) throw new Error('Not an Email');

    super(email);
  }

  static validate(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
  }

  toString(): string {
    return this.value;
  }
}
